import { queryAll, query, fromId } from '../utils/utils.js';

export class Overview {
    root = query('body');

    constructor() {
        
        if (query('.b-overview-block') === null) {
            this.createOverviewBlockContainer();
        }

    }

    createOverviewBlockContainer() {
         // TODO : Make sure the the other blocks are siblings and not just randomly on the page

        const overviewCardsBlocks = queryAll('.b-overview-cards-block');
        console.log('[BHS] - grouping overview cards blocks');
        if(overviewCardsBlocks.length > 0 ) {
            // check to see if all the blocks are siblings
            let areSiblings = true;
            for(let i = 0; i < overviewCardsBlocks.length; i++) {
                if(overviewCardsBlocks[i].parentNode !== overviewCardsBlocks[0].parentNode) {
                    areSiblings = false;
                }
            }

            if( !areSiblings ) {
                console.log('[BHS] - overview cards blocks are not siblings');
                return;
            }
            
            let prev = null;
            const newDiv = document.createElement('section');
            newDiv.classList.add('b-overview-block');

            overviewCardsBlocks.forEach( (overviewCardsBlock , i) => {

                if (prev) {
                    console.log(prev.nextElementSibling == overviewCardsBlock);
                }

                if (i == 0) overviewCardsBlock.parentNode.insertBefore(newDiv, overviewCardsBlock);
                newDiv.appendChild(overviewCardsBlock);

                prev = overviewCardsBlock;
            });
        }

    }

}
